/** After signup, send the user to the email-verification instructions screen. */
export function goToVerifyEmailPending(history, email) {
  const normalized = String(email || '').trim().toLowerCase();
  history.push({
    pathname: '/verify-email-pending',
    search: normalized ? `?email=${encodeURIComponent(normalized)}` : '',
  });
}
